/*
 * @author : Kete Martins Rufino
 * @email  : kete@sagaranatech.com
 */



Greenmile.Components = Greenmile.Components || {};

Greenmile.Components.FileUploader = (function () {

    function FileUploader (params) {

        var MAX_FILE_SIZE = 250000000;

        var inputSelector = params.inputSelector,
            input = params.input || document.getElementById(inputSelector),
            dropSelector = params.dropSelector,
            dropArea = params.dropArea || document.querySelector(dropSelector),
            formdata = new FormData();

        var showBlockOverlay = function() {
            this.scopeBlock.classList.add("drop");
        }.bind(this);


        var hideBlockOverlay = function() {
            this.scopeBlock.classList.remove("drop");
        }.bind(this);

        this.createBlockOverlay = function() {
            this.scopeBlock = dropArea;
            hideBlockOverlay();
        };

        this.sendFiles = function(eventContext) {
           formdata = new FormData();
           var files = (eventContext.dataTransfer ? eventContext.dataTransfer.files : eventContext.target.files),
                len = files.length , reader, file,
                onloadend = function (e) {
                   params.statusCallback(e.target.result);
                },
               onprogress = function (e) {
                   params.statusCallback(e.target.result);
               };

            for (var i = 0 ; i < len; i++ ) {
                file = files[i];

                if(file.size > MAX_FILE_SIZE && params.errorCallback){
                    var errorMessage = {errorMessage: {message: Monet.I18n.getResourcesByKey('Greenmile.DataImport.fileIsTooBig', (MAX_FILE_SIZE/1000000))}};
                    params.errorCallback(errorMessage);
                    return;
                }

                if ( window.FileReader ) {
                    reader = new FileReader();
                    if(params.statusCallback) {
                        reader.onloadend = onloadend;

                        reader.onprogress = onprogress;
                    }
                    reader.readAsDataURL(file);
                }
                if (formdata) {
                    formdata.append("file", file);
                }
            }

            if (formdata && formdata.get("file")) {
                var ajax = new Monet.Ajax({ contentType: 'multipart/form-data' });
                ajax.url = "/TextFileUpload/Create";
                ajax.data = formdata;
                ajax.method = "POST";
                ajax.processData = false;

                ajax.success = function (res) {
                    if(params.successCallback) {
                        params.successCallback(res);
                    }
                };

                ajax.error = function (e) {
                    if(params.errorCallback) {
                        params.errorCallback(e);
                    }
                };

                ajax.send();
            }
        };

        this.dropLeave = function(event){
            event.stopPropagation();
            event.preventDefault();

            hideBlockOverlay();

        }.bind(this);

        this.dragOver = function(event){

            event.stopPropagation();
            event.preventDefault();

            showBlockOverlay();

        }.bind(this);

        this.drop = function(event) {

            event.preventDefault();
            event.stopPropagation();

            this.sendFiles(event);

            hideBlockOverlay();

        }.bind(this);

        this.disableEvents = function() {
            dropArea.removeEventListener('dragover', this.dragOver);
            this.scopeBlock.removeEventListener('drop', this.drop);
            this.scopeBlock.removeEventListener('dragleave', this.dropLeave);
        };

        this.addEventListeners = function() {
            this.scopeBlock.addEventListener("drop", this.drop);

            dropArea.addEventListener("dragover", this.dragOver);

            this.scopeBlock.addEventListener("dragleave", this.dropLeave);

            input.addEventListener("change", this.sendFiles);

        };

        this.render = function() {
            this.createBlockOverlay();
            this.addEventListeners();
        };


    }

    return FileUploader;

}());
